import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Buefy from "buefy";
import "@/assets/styles/settings.scss";
import * as Sentry from "@sentry/vue";
import setupIframeNavigationHandler, { setupVueRouterIntegration } from "@/utils/iframe-navigation-handler";

Sentry.init({
  Vue,
  dsn: "https://2fdd74712f314ab587bd962f426c9281@glitch-xi26lpr5.flightsite.co.za/3",
  enabled: process.env.NODE_ENV === 'production',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: 0.5,
  tracePropagationTargets: ["http://localhost:*", "https://cars.investectravel.com"]
});

Vue.use(Buefy);
window.Vue = Vue;

Vue.config.productionTip = true;

// Setup iframe navigation handlers for both link clicks and Vue Router
setupIframeNavigationHandler();  // Handles <a> link clicks
setupVueRouterIntegration(router);  // Handles programmatic Vue Router navigation

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
